import { useSelector } from "react-redux"

const num = (v, def = 0) => {
	const n = parseFloat(v)
	return isNaN(n) ? def : n
}

// Selector pur : sort la tarification du Master (extra_data.tarification),
// valeurs castées en nombres. Utilisable dans mapStateToProps ET useSelector.
// C'est LA source de tarif (la table Option / slice options sont en voie de
// suppression). Le tarif est lu à la création d'une fiche puis snapshoté dessus.
export const selectTarif = (state) => {
	let ed =
		state.masterReducer &&
		state.masterReducer.masterEntite &&
		state.masterReducer.masterEntite.extra_data
	if (typeof ed === "string") {
		try {
			ed = JSON.parse(ed)
		} catch (e) {
			ed = {}
		}
	}
	const t = (ed && ed.tarification) || {}
	const g = t.generale || {}
	const a = t.atelier || {}
	const l = t.location || {}
	return {
		tva: num(g.tva),
		coutHoraire: num(a.coutHoraire),
		prixHoraire: num(a.prixHoraire),
		prixHoraireSociete: num(a.prixHoraireSociete),
		prixHoraireAssurance: num(a.prixHoraireAssurance),
		tarifJournalier: num(l.tarifJournalier),
	}
}

// Hook pour les composants fonctionnels : const { tva, prixHoraire } = useTarif()
export const useTarif = () => useSelector(selectTarif)

export default useTarif
